import {
  NS_GET_INVEST_LIST_DATA,
  NS_GET_INVEST_LIST_DATA_SUCCESS,
  NS_GET_INVEST_LIST_DATA_FAIL,
  NS_GET_CUSTOMER_TYPE_LIST,
  NS_GET_CUSTOMER_TYPE_LIST_SUCCESS,
  NS_GET_CUSTOMER_TYPE_LIST_FAIL,
  NS_SEND_TO_CM,
  NS_SEND_TO_CM_FAIL,
  NS_SEND_TO_CM_SUCCESS
} from '../../actions/ns/investigation';

export const initialState = {
  isLoading: false,
  isLoadingList: false,
  alertList: [],
  hasError: false,
  alertCounts: {},
  error: null,
  customerType: [],
  sendToCM: {
    isLoading: false
  }
};

function nsInvestigation(state = initialState, action) {
  switch (action.type) {
    case NS_GET_INVEST_LIST_DATA:
      return {
        ...state,
        isLoading: true,
        isLoadingList: true,
        hasError: false,
        error: null
      };
    case NS_GET_INVEST_LIST_DATA_SUCCESS:
      return {
        ...state,
        alertList: action.payload.alerts,
        alertCounts: action.payload.alertCounts,
        isLoading: false,
        isLoadingList: false,
        error: null
      };
    case NS_GET_INVEST_LIST_DATA_FAIL:
      return {
        ...state,
        alertList: [],
        isLoading: false,
        isLoadingList: false,
        hasError: true,
        ...action.payload
      };
    case NS_GET_CUSTOMER_TYPE_LIST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case NS_GET_CUSTOMER_TYPE_LIST_SUCCESS:
      return {
        ...state,
        customerType: action.payload,
        isLoading: false,
        error: null
      };
    case NS_GET_CUSTOMER_TYPE_LIST_FAIL:
      return {
        ...state,
        customerType: [],
        isLoading: false,
        ...action.payload
      };
    case NS_SEND_TO_CM:
      return {
        ...state,
        sendToCM: {
          ...state.sendToCM,
          isLoading: true
        }
      };
    case NS_SEND_TO_CM_SUCCESS:
      return {
        ...state,
        sendToCM: {
          ...state.sendToCM,
          isLoading: false
        }
      };
    case NS_SEND_TO_CM_FAIL:
      return {
        ...state,
        sendToCM: {
          ...state.sendToCM,
          isLoading: false
        }
      };
    default:
      return {
        ...state
      };
  }
}

export default nsInvestigation;
